import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons"
import { Form } from "antd"
import React, { useEffect, useRef, useState } from "react"
// import "./directorfileUpload.css"
import upload from "../../assets/images/upload.svg"
// import useNotify from "src/hooks/useNotify"
// import { getPresignedURlDirector } from "src/apis/signup"
// import { showLoader } from "src/store/states/isLoading"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { inwardPartner, showloader } from "../../store/gloabalState"
import useNotify from "../../utils/useNotify"
import { getPresignedURlDirector } from "../../services/httpCalls"
import PreviewDocsModalProbe from "./previewDocsModalProbe"
import { display } from "@mui/system"
import { checkFileExtension } from "../../utils/check-file-extension"

const DirectorFileComponent = props => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileName, setFileName] = useState("")
  const [refresh, setRefresh] = useState(false)
  const [alreadyuploadedList, setAlreadyUploadedList] = useState({
    DIRECTOR_PAN: false,
    DIRECTOR_ADHAAR: false,
    DIRECTOR_PASSPORT: false
  })
  const [uploadedDocumentsList, setUploadedDocumentsList] = useState({
    DIRECTOR_PAN: "",
    DIRECTOR_ADHAAR: "",
    DIRECTOR_PASSPORT: ""
  })
  const [uploadedDocumentsListUrl, setUploadedDocumentsListUrl] = useState({
    DIRECTOR_PAN: "",
    DIRECTOR_ADHAAR: "",
    DIRECTOR_PASSPORT: ""
  })
  const [errorMessage, setErrorMessage] = useState("")
  const setShowLoader = useSetRecoilState(showloader)
  const inputRef = useRef()
  const notify = useNotify()
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type }
    })
  }
  const partnerState = useRecoilValue(inwardPartner)

  const resetFile = () => {
    // setErrorMessage('')
    setFileName("")
    setSelectedFile(null)
    inputRef.current.value = null
  }
  const directorDocsUpload = async (files, docType) => {
    let preSignedUrl
    if (files.length) {
      setShowLoader(true)
      let orgId = localStorage.getItem("orgId")
      await getPresignedURlDirector(orgId, files[0].name)
        .then(async res => {
          preSignedUrl = res.preSignedUrl.split("?")[0]
          await uploadFileToS3(res.preSignedUrl, files[0])
            .then(async () => {
              let dirDocsType = {
                documentType: props.name,
                url: preSignedUrl
              }

              // await addOrgDocs(OrgData, orgId)
              //     .then((res) => {
              //         notify.success(`${name.replaceAll("_", " ")} UPLOADED`);
              //         setErrorMessage('')
              //         // resetFile()
              //         // setRefreshDocs(!refresh)

              //     })
              //     .catch((err) => {
              //         notify.error("Error while uploading!");
              //         setErrorMessage("Error while uploading!")
              //         resetFile()
              //     })
              //     .finally(() => {
              //         setShowLoader(false);
              //     });
              // directorDocumentsArray.push(dirDocsType)
              if (props.name === "DIRECTOR_PAN") {
                props.setDirectorsDocsPAN([dirDocsType])
              } else if (props.name === "DIRECTOR_ADHAAR") {
                props.setDirectorsDocsAADHAR([dirDocsType])
              } else {
                props.setDirectorsDocsPASSPORT([dirDocsType])
              }
              setErrorMessage("")
              setRefresh(!refresh)
            })
            .catch(err => {
              notify.error("Error while uploading to S3")
              setErrorMessage("Error while uploading to S3")
              resetFile()
            })
            .finally(() => setShowLoader(false))
        })
        .catch(err => {
          notify.error("Error genrating Presigned URL")
          setErrorMessage(
            "Please remove special characters from file name such as [,#,!,@,~,&,$,%,*,/,|,?,<,}"
          )
          resetFile()
        })
        .finally(() => setShowLoader(false))
    }
  }
  const validFileSize = (size, name) => {
    if (size * 0.001 >= 1024 * 10) {
      notify.error("File size is more than 10MB!")
      setErrorMessage("Please upload file with size less than 10MB")
      resetFile()
      return false
    }
    return true
  }
  function hasSpecialCharacters(filename) {
    const regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/
    return regex.test(filename)
  }
  const handleFileSelect = e => {
    if (e.target.files?.length) {
      if(!checkFileExtension(e.target?.files[0]?.name)){
        notify.error("Please upload a file with proper extension!");
        resetFile();
      }
      if (!hasSpecialCharacters(e.target?.files[0]?.name)) {
        let sizeofFile = e.target.files[0]?.size
        if (validFileSize(sizeofFile, e.target.name)) {
          setSelectedFile(e?.target?.files?.[0])
          setFileName(e?.target.files[0]?.name)
          directorDocsUpload(e.target.files, e.target.name)
        }
      } else {
        setErrorMessage(
          "Please remove special characters from file name such as [,(),#,!,@,~,&,$,%,*,/,|,?,<,} and re-upload eg. XYZ.pdf or xyz123 file.pdf"
        )
        resetFile()
      }
    } else {
      notify.error("No file Selected!")
      resetFile()
    }
  }
  let uploadedDocstype = {
    DIRECTOR_PAN: false,
    DIRECTOR_ADHAAR: false,
    DIRECTOR_PASSPORT: false
  }
  let uploadedList_ = {
    DIRECTOR_PAN: "",
    DIRECTOR_ADHAAR: "",
    DIRECTOR_PASSPORT: ""
  }
  let uploadedList_Url = {
    DIRECTOR_PAN: "",
    DIRECTOR_ADHAAR: "",
    DIRECTOR_PASSPORT: ""
  }
  const checkUploadedDocsDirector = () => {
    if (props.editDirector !== true) {
      setAlreadyUploadedList({
        DIRECTOR_PAN: false,
        DIRECTOR_ADHAAR: false,
        DIRECTOR_PASSPORT: false
      })
      setUploadedDocumentsList({
        DIRECTOR_PAN: "",
        DIRECTOR_ADHAAR: "",
        DIRECTOR_PASSPORT: ""
      })
      setUploadedDocumentsListUrl({
        DIRECTOR_PAN: "",
        DIRECTOR_ADHAAR: "",
        DIRECTOR_PASSPORT: ""
      })
      setFileName("")
    } else {
      setFileName("")
      if (props.docsDirectors?.length) {
        props.docsDirectors?.forEach(val => {
          if (val.type === "DIRECTOR_PAN") {
            props.form.setFieldValue('DIRECTOR_PAN', val)
            uploadedDocstype["DIRECTOR_PAN"] = true
            uploadedList_["DIRECTOR_PAN"] = val?.name
            uploadedList_Url["DIRECTOR_PAN"] = val?.s3Url.split("amazonaws.com/")[1]
            ? val?.s3Url.split("amazonaws.com/")[1]
            : ""
          }
          if (val.type === "DIRECTOR_ADHAAR") {
            props.form.setFieldValue('DIRECTOR_ADHAAR', val)
            uploadedDocstype["DIRECTOR_ADHAAR"] = true
            uploadedList_["DIRECTOR_ADHAAR"] = val?.name
            uploadedList_Url["DIRECTOR_ADHAAR"] = val?.s3Url.split("amazonaws.com/")[1]
            ? val?.s3Url.split("amazonaws.com/")[1]
            : ""
          }
          if (val.type === "DIRECTOR_PASSPORT") {
            props.form.setFieldValue('DIRECTOR_PASSPORT', val)
            uploadedDocstype["DIRECTOR_PASSPORT"] = true
            uploadedList_["DIRECTOR_PASSPORT"] = val?.name
            uploadedList_Url["DIRECTOR_PASSPORT"] = val?.s3Url.split("amazonaws.com/")[1]
            ? val?.s3Url.split("amazonaws.com/")[1]
            : ""
          }
        })
      }
    }
    setUploadedDocumentsListUrl(uploadedList_Url)
    setAlreadyUploadedList(uploadedDocstype)
    setUploadedDocumentsList(uploadedList_)
  }
  useEffect(() => {
    checkUploadedDocsDirector()
  }, [props.name, props.type, props.recheckDocs, props.editDirector])

  const isDocumentRequired = ((partnerState?.includes("payglocal") || props.selectionValue !== "inward") && props.editDirector) ? false : true;

  return (
    <Form.Item
      label={
        <>
          {
            <div style={{
              display:"flex",
                  alignItems: 'center'
            }}>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: ".9rem",
                  letterSpacing: ".5px",
                  paddingRight:'.5rem'
                }}
              >
                {props.type}
              </span>{" "}
              {fileName ? (
                <>
                  {" "}
                  <CheckCircleFilled
                    style={{
                      color: "green",
                      fontSize: "16px"
                    }}
                  />
                </>
              ) : alreadyuploadedList[props.name] ? (
                <>
                  <CheckCircleFilled
                    style={{
                      color: "green",
                      fontSize: "16px"
                    }}
                  />
                  <PreviewDocsModalProbe url={uploadedDocumentsListUrl[props.name]} />
                </>
              ) : (
                <ExclamationCircleFilled
                  style={{
                    color: "red",
                    fontSize: "16px"
                  }}
                />
              )}
            </div>
          }
        </>
      }
      required
      name={props.name}
      labelCol={{ span: 16 }}
      rules={[
        {
          required: isDocumentRequired,
          message: "Please upload document"
        }
      ]}
    >
      <div style={{ margin: "0.5rem 0" }}>
        <div
          className={`${errorMessage
              ? "border-error"
              : alreadyuploadedList[props.name]
                ? "border-uploaded"
                : "border"
            }`}
        >
          <div className="file-upload">
            <img src={upload} alt="" />

            <h4 className="filename_text">
              {" "}
              {fileName
                ? fileName
                : uploadedDocumentsList[props.name] !== ""
                  ? uploadedDocumentsList[props.name]
                  : "No file Selected"}
            </h4>

            <input type="file"
              onChange={handleFileSelect}
              ref={inputRef} />
            <div />
          </div>
        </div>
        <p className="error_message">{errorMessage ? errorMessage : ""}</p>
      </div>
    </Form.Item>
  )
}

export default DirectorFileComponent
